import React from "react";
import { Grid } from "semantic-ui-react";
import Presets from "./presets";
import Selectors from "./selectors";

const Settings = ({ retailer, id, data }) => {
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column computer={4} tablet={4} mobile={16}>
          <Presets retailer={retailer} id={id} />
        </Grid.Column>
        <Grid.Column computer={12} tablet={12} mobile={16}>
          <Selectors retailer={retailer} id={id} tdata={data} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default Settings;
